export enum EPlatformType {
    WEB = 'WEB',
    IOS = 'IOS',
    ANDROID = 'ANDROID',
}

export enum DevicePlatform {
    DESKTOP = 'DESKTOP',
    MOBILE = 'MOBILE',
    TABLET = 'TABLET',
}
